import { Check, ContentCopy } from "@mui/icons-material";
import { styled, SxProps, Theme } from "@mui/material";
import { useState } from "react";

type CopyToClipboardProps = {
  text: string;
  sx?: SxProps<Theme>;
};

const CopyToClipboard = ({ text, sx }: CopyToClipboardProps) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setClicked(true);
      setTimeout(() => {
        setClicked(false);
      }, 1000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Wrap onClick={handleClick}>
      {clicked ? (
        <Check style={{ opacity: 1 }} color="success" />
      ) : (
        <ContentCopy sx={sx} />
      )}
    </Wrap>
  );
};

const Wrap = styled('div')`
  opacity: 0.7;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

export default CopyToClipboard;
